(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["wix-dom-sanitizer"] = factory();
	else
		root["wix-dom-sanitizer"] = factory();
})(this, function() {
return 